export enum PulsarMessageTypeEnum {
  HEALTH_STATUS = 'health_status',
  PING = 'ping',
  PONG = 'pong',
  GET_CURRENT_STATUS = 'get_current_status',
  AUTHENTICATE = 'authenticate',
  LOGOUT = 'logout',
  SESSION = 'session',
  AUTH_ERROR = 'auth_error',
  EMISSION_VALIDATION_EVENT = 'emission_validation_event',
  LOCK_EVENT = 'lock_event'
}
